import { postTo } from "src/store/dataService/routes/shared/osfetch";

export const scheduleAppointmentToApi = (uuid: string, schedule: any) => {
    return postTo(`/deals/${uuid}/appointment/pick_up`, schedule).then((response: Response) => {
        if (!response.ok) {
            throw new Error("Unable to schedule an appointment");
        }
        return response.json();
    });
};
